export default "__VITE_PUBLIC_ASSET__cc865aa1__"